var extractStyles = function () {
    return Array.from(document.styleSheets)
        .map(function (styleSheet) {
        try {
            return styleSheet.cssRules
                ? Array.from(styleSheet.cssRules)
                    .map(function (rule) { return rule.cssText; })
                    .join('\n')
                : '';
        }
        catch (e) {
            // Stylesheets from different origins will throw security errors
            return '';
        }
    })
        .filter(Boolean)
        .join('\n');
};
var createPrintHTML = function (styles, contentHTML) {
    return "\n    <!DOCTYPE html>\n        <html>\n          <head>\n            <title>Certificate</title>\n            <style>\n              ".concat(styles, "\n              body { margin: 0; padding: 0; }\n              @media print {\n                body { -webkit-print-color-adjust: exact; }\n              }\n            </style>\n          </head>\n          <body>\n            ").concat(contentHTML, "\n          </body>\n        </html>\n    ");
};
var openPrintWindow = function (printHtml) {
    var blob = new Blob([printHtml], { type: 'text/html' });
    var url = URL.createObjectURL(blob);
    var printWindow = window.open(url, '_blank');
    if (printWindow) {
        printWindow.onload = function () {
            printWindow.focus();
            setTimeout(function () {
                printWindow.print();
                // Don't close immediately to allow printing
                setTimeout(function () { return printWindow.close(); }, 1000);
            }, 500);
        };
    }
    else {
        // eslint-disable-next-line no-console
        console.error('Print reference is null or window could not be opened');
    }
};
var handlePrintCustom = function (printableContentRef) {
    var _a, _b;
    var styles = extractStyles();
    var contentHTML = (_b = (_a = printableContentRef.current) === null || _a === void 0 ? void 0 : _a.outerHTML) !== null && _b !== void 0 ? _b : '';
    var printHTML = createPrintHTML(styles, contentHTML);
    openPrintWindow(printHTML);
};
export { handlePrintCustom };
